<template>
	<div class="color-field">
		<div class="color-field__head">
			<label class="pp-label mb-0">{{ label }}</label>
			<v-spacer></v-spacer>
			<v-btn v-if="clearable && value" x-small text color="primary" class="color-field__clear" @click="$emit('input', '')">Rimuovi</v-btn>
		</div>
		<v-menu offset-y :close-on-content-click="false">
			<template v-slot:activator="{ on }">
				<button type="button" class="color-field__box" v-on="on">
					<span class="color-field__swatch" :class="{ 'color-field__swatch--unset': !value }" :style="value ? { background: value } : null"></span>
					<span class="color-field__value" :class="{ 'color-field__value--unset': !value }">{{ value ? value.toUpperCase() : placeholder }}</span>
				</button>
			</template>
			<!-- Senza colore il selettore parte dal bianco: con value vuoto Vuetify emette il suo rosso
			     appena si apre, e il solo guardare il menu impostava un colore -->
			<v-color-picker :value="value || '#FFFFFF'" mode="hexa" hide-mode-switch @input="$emit('input', $event)"></v-color-picker>
		</v-menu>
	</div>
</template>

<script>
/**
 * Input:  value (colore o ''), label, clearable, placeholder (testo quando non impostato)
 * Fa:     riga etichetta + campione col codice del colore; il clic apre il selettore
 * Output: evento input(colore), '' da "Rimuovi"
 */
export default {
	name: 'color-field',

	props: {
		value: { type: String, default: '' },
		label: { type: String, default: '' },
		clearable: { type: Boolean, default: false },
		placeholder: { type: String, default: 'Non impostato' }
	}
}
</script>

<style scoped>
.color-field__head {
	display: flex;
	align-items: center;
	min-height: 22px;
	margin-bottom: 4px;
}

.color-field__clear {
	margin-right: -6px;
}

.color-field__box {
	display: flex;
	align-items: center;
	width: 100%;
	height: 40px;
	padding: 0 10px;
	border: 1px solid rgba(0, 0, 0, 0.38);
	border-radius: 4px;
	background: #fff;
	cursor: pointer;
	text-align: left;
	transition: border-color 0.15s;
}

.color-field__box:hover {
	border-color: rgba(0, 0, 0, 0.87);
}

.color-field__swatch {
	flex: 0 0 auto;
	width: 24px;
	height: 24px;
	margin-right: 10px;
	border-radius: 4px;
	/* anche un colore bianco resta visibile come campione */
	box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.2);
}

/* Colore non impostato: tratteggio invece di un colore finto */
.color-field__swatch--unset {
	background-image: repeating-linear-gradient(135deg, #d6d6d6 0 3px, #fff 3px 6px);
}

.color-field__value {
	font-size: 14px;
	font-family: 'Roboto Mono', monospace;
	color: rgba(0, 0, 0, 0.87);
}

.color-field__value--unset {
	font-family: inherit;
	font-style: italic;
	color: rgba(0, 0, 0, 0.6);
}
</style>
